import React, { useState, useEffect } from 'react'
import emailjs from 'emailjs-com';

// reactstrap components
import {
  Button,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Alert,
} from "reactstrap";
import ContactPageHeader from "components/Headers/ContactPageHeader.js";
import DemoFooter from "components/Footers/DemoFooter.js";
import Chat from './Chat';
import ServicesNavbar from 'components/Navbars/ServicesNavbar';

const Contact = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [formStatus, setFormStatus] = useState(''); // 'success', 'error', ''

  useEffect(() => {
    setIsVisible(true);
  }, []);

  function sendEmail(e) {
    e.preventDefault();
    setFormStatus('sending');

    emailjs.sendForm('gmail', 'nour', e.target, 'user_5meN3rp2zzqeUD2oTp7Pq')
      .then((result) => {
        console.log(result.text);
        setFormStatus('success');
        e.target.reset();
        setTimeout(() => setFormStatus(''), 5000);
      }, (error) => {
        console.log(error.text);
        setFormStatus('error');
        setTimeout(() => setFormStatus(''), 5000);
      });
  }

  const contactMethods = [
    {
      icon: "📧",
      title: "Email Us",
      description: "Send us a detailed message and we'll get back to you within 24 hours.",
      contact: "triadvise@gmail.com",
      action: "mailto:triadvise@gmail.com"
    },
    {
      icon: "💬",
      title: "WhatsApp",
      description: "Get instant responses and quick consultations via WhatsApp.",
      contact: "+961 81 906 656",
      action: "https://api.whatsapp.com/send/?phone=%2B96181906656&text&type=phone_number&app_absent=0"
    },
    {
      icon: "📱",
      title: "Live Chat",
      description: "Chat with our team in real-time for immediate assistance.",
      contact: "Available 9 AM - 6 PM",
      action: "#chat"
    }
  ];

  return (
    <div>
      <ServicesNavbar />
      <ContactPageHeader />

      {/* Hero Section */}
      <div style={{
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        padding: '100px 0',
        position: 'relative',
        overflow: 'hidden'
      }}>
        {/* Animated Background Elements */}
        <div style={{
          position: 'absolute',
          top: '10%',
          left: '5%',
          width: '200px',
          height: '200px',
          background: 'rgba(255,255,255,0.1)',
          borderRadius: '50%',
          animation: 'float 6s ease-in-out infinite'
        }}></div>
        
        <div style={{
          position: 'absolute',
          bottom: '15%',
          right: '8%',
          width: '150px',
          height: '150px',
          background: 'rgba(255,255,255,0.05)',
          borderRadius: '50%',
          animation: 'float 8s ease-in-out infinite 2s'
        }}></div>

        <Container style={{ position: 'relative', zIndex: 2 }}>
          <Row>
            <Col className="text-center">
              <div style={{
                opacity: isVisible ? 1 : 0,
                transform: isVisible ? 'translateY(0)' : 'translateY(30px)',
                transition: 'all 1s ease-out'
              }}>
                <h1 style={{
                  color: 'white',
                  fontSize: '4rem',
                  fontWeight: '700',
                  marginBottom: '30px',
                  textShadow: '0 4px 10px rgba(0,0,0,0.4)'
                }}>
                  💬 Let's Connect
                </h1>
                
                <h2 style={{
                  color: '#feca57',
                  fontSize: '2.5rem',
                  fontWeight: '600',
                  marginBottom: '40px',
                  textShadow: '0 2px 6px rgba(0,0,0,0.3)'
                }}>
                  Ready to Start Your Project?
                </h2>

                <p style={{
                  color: 'rgba(255,255,255,0.9)',
                  fontSize: '1.4rem',
                  maxWidth: '800px',
                  margin: '0 auto 50px',
                  lineHeight: '1.8',
                  textShadow: '0 2px 4px rgba(0,0,0,0.3)'
                }}>
                  We're here to help you achieve your digital goals. Choose your preferred way to get in touch 
                  and let's discuss how we can bring your vision to life!
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Contact Methods Section */}
      <div style={{
        background: 'white',
        padding: '120px 0',
        position: 'relative'
      }}>
        <Container>
          <Row>
            <Col className="text-center" style={{ marginBottom: '80px' }}>
              <h2 style={{
                color: '#333',
                fontSize: '3.5rem',
                fontWeight: '700',
                marginBottom: '30px'
              }}>
                Get In Touch
              </h2>
              <div style={{
                width: '100px',
                height: '5px',
                background: 'linear-gradient(90deg, #667eea, #764ba2)',
                margin: '0 auto 40px',
                borderRadius: '3px'
              }}></div>
              <p style={{
                color: '#666',
                fontSize: '1.3rem',
                maxWidth: '700px',
                margin: '0 auto',
                lineHeight: '1.8'
              }}>
                Multiple ways to reach us - choose what works best for you
              </p>
            </Col>
          </Row>

          <Row>
            {contactMethods.map((method, index) => (
              <Col md="4" style={{ marginBottom: '40px' }} key={index}>
                <Card style={{
                  background: 'white',
                  borderRadius: '25px',
                  border: 'none',
                  boxShadow: '0 15px 35px rgba(0,0,0,0.1)',
                  transition: 'all 0.4s ease',
                  height: '100%',
                  textAlign: 'center'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-15px)';
                  e.currentTarget.style.boxShadow = '0 25px 50px rgba(0,0,0,0.2)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 15px 35px rgba(0,0,0,0.1)';
                }}>
                  <CardBody style={{ padding: '40px 30px' }}>
                    <div style={{
                      fontSize: '4rem',
                      marginBottom: '25px'
                    }}>
                      {method.icon}
                    </div>
                    
                    <h3 style={{
                      color: '#333',
                      fontSize: '1.8rem',
                      fontWeight: '600',
                      marginBottom: '20px'
                    }}>
                      {method.title}
                    </h3>
                    
                    <p style={{
                      color: '#666',
                      fontSize: '1.1rem',
                      lineHeight: '1.7',
                      marginBottom: '25px'
                    }}>
                      {method.description}
                    </p>

                    <p style={{
                      color: '#667eea',
                      fontSize: '1.2rem',
                      fontWeight: '600',
                      marginBottom: '30px'
                    }}>
                      {method.contact}
                    </p>

                    <Button
                      className="btn-round"
                      style={{
                        background: 'linear-gradient(45deg, #667eea, #764ba2)',
                        border: 'none',
                        padding: '15px 35px',
                        borderRadius: '30px',
                        color: 'white',
                        fontWeight: '600',
                        fontSize: '1.1rem',
                        boxShadow: '0 8px 25px rgba(102, 126, 234, 0.3)',
                        transition: 'all 0.3s ease'
                      }}
                      href={method.action}
                      target={method.action.startsWith('http') ? '_blank' : '_self'}
                    >
                      {method.title === 'Email Us' ? 'Send Email' : 
                       method.title === 'WhatsApp' ? 'Chat on WhatsApp' : 
                       'Start Chat'}
                    </Button>
                  </CardBody>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </div>

      {/* Contact Form Section */}
      <div id="contact-form" style={{
        background: 'linear-gradient(135deg, #7C3AED 0%, #EC4899 100%)',
        padding: '120px 0',
        position: 'relative'
      }}>
        <Container>
          <Row>
            <Col className="text-center" style={{ marginBottom: '60px' }}>
              <h2 style={{
                color: 'white',
                fontSize: '3.5rem',
                fontWeight: '700',
                marginBottom: '30px',
                textShadow: '0 4px 8px rgba(0,0,0,0.3)'
              }}>
                Send Us a Message
              </h2>
              <div style={{
                width: '120px',
                height: '5px',
                background: 'linear-gradient(90deg, #ff6b6b, #feca57)',
                margin: '0 auto 40px',
                borderRadius: '3px'
              }}></div>
              <p style={{
                color: 'rgba(255,255,255,0.9)',
                fontSize: '1.3rem',
                maxWidth: '600px',
                margin: '0 auto',
                lineHeight: '1.8'
              }}>
                Have a specific project in mind? Fill out our form and we'll get back to you with a detailed proposal.
              </p>
            </Col>
          </Row>

          <Row>
            <Col md="8" style={{ margin: '0 auto' }}>
              <Card style={{
                background: 'rgba(255,255,255,0.1)',
                backdropFilter: 'blur(15px)',
                borderRadius: '25px',
                border: '2px solid rgba(255,255,255,0.2)',
                boxShadow: '0 20px 60px rgba(0,0,0,0.3)'
              }}>
                <CardBody style={{ padding: '50px' }}>
                  {formStatus === 'success' && (
                    <Alert color="success" style={{ marginBottom: '30px' }}>
                      <i className="fa fa-check-circle" style={{ marginRight: '10px' }} />
                      Thank you! Your message has been sent successfully. We'll get back to you soon!
                    </Alert>
                  )}
                  
                  {formStatus === 'error' && (
                    <Alert color="danger" style={{ marginBottom: '30px' }}>
                      <i className="fa fa-exclamation-triangle" style={{ marginRight: '10px' }} />
                      Sorry, there was an error sending your message. Please try again or contact us directly.
                    </Alert>
                  )}

                  {formStatus === 'sending' && (
                    <Alert color="info" style={{ marginBottom: '30px' }}>
                      <i className="fa fa-spinner fa-spin" style={{ marginRight: '10px' }} />
                      Sending your message...
                    </Alert>
                  )}

                  <Form className="contact-form" onSubmit={sendEmail}>
                    <Row>
                      <Col md="6">
                        <label style={{ color: "white", fontSize: "1.1rem", fontWeight: "600", marginBottom: "10px", display: "block" }}>
                          <i className="fa fa-user" style={{ marginRight: '8px' }} />
                          Full Name
                        </label>
                        <InputGroup style={{ marginBottom: '25px' }}>
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText style={{ background: 'rgba(255,255,255,0.2)', border: '1px solid rgba(255,255,255,0.3)', color: 'white' }}>
                              <i className="nc-icon nc-single-02" />
                            </InputGroupText>
                          </InputGroupAddon>
                          <Input 
                            placeholder="Enter your full name" 
                            type="text" 
                            name="name" 
                            required
                            style={{ 
                              background: 'rgba(255,255,255,0.1)', 
                              border: '1px solid rgba(255,255,255,0.3)',
                              color: 'white',
                              fontSize: '1.1rem'
                            }}
                          />
                        </InputGroup>
                      </Col>
                      <Col md="6">
                        <label style={{ color: "white", fontSize: "1.1rem", fontWeight: "600", marginBottom: "10px", display: "block" }}>
                          <i className="fa fa-envelope" style={{ marginRight: '8px' }} />
                          Email Address
                        </label>
                        <InputGroup style={{ marginBottom: '25px' }}>
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText style={{ background: 'rgba(255,255,255,0.2)', border: '1px solid rgba(255,255,255,0.3)', color: 'white' }}>
                              <i className="nc-icon nc-email-85" />
                            </InputGroupText>
                          </InputGroupAddon>
                          <Input 
                            placeholder="Enter your email" 
                            type="email" 
                            name="email" 
                            required
                            style={{ 
                              background: 'rgba(255,255,255,0.1)', 
                              border: '1px solid rgba(255,255,255,0.3)',
                              color: 'white',
                              fontSize: '1.1rem'
                            }}
                          />
                        </InputGroup>
                      </Col>
                    </Row>
                    
                    <label style={{ color: "white", fontSize: "1.1rem", fontWeight: "600", marginBottom: "10px", display: "block" }}>
                      <i className="fa fa-comment" style={{ marginRight: '8px' }} />
                      How Can We Help You?
                    </label>
                    <Input
                      placeholder="Describe your project, goals, or any questions you have. Be as detailed as possible..."
                      type="textarea"
                      rows="6"
                      name="message"
                      required
                      style={{ 
                        background: 'rgba(255,255,255,0.1)', 
                        border: '1px solid rgba(255,255,255,0.3)',
                        color: 'white',
                        fontSize: '1.1rem',
                        marginBottom: '30px'
                      }}
                    />
                    
                    <div className="text-center">
                      <Button 
                        className="btn-round" 
                        style={{
                          background: 'linear-gradient(45deg, #ff6b6b, #feca57)',
                          border: 'none',
                          padding: '18px 50px',
                          borderRadius: '35px',
                          color: 'white',
                          fontWeight: '700',
                          fontSize: '1.3rem',
                          boxShadow: '0 10px 30px rgba(255, 107, 107, 0.4)',
                          transition: 'all 0.3s ease'
                        }}
                        size="lg" 
                        type="submit"
                        disabled={formStatus === 'sending'}
                      >
                        {formStatus === 'sending' ? (
                          <>
                            <i className="fa fa-spinner fa-spin" style={{ marginRight: '10px' }} />
                            Sending...
                          </>
                        ) : (
                          <>
                            <i className="fa fa-paper-plane" style={{ marginRight: '10px' }} />
                            Send Message
                          </>
                        )}
                      </Button>
                    </div>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Add keyframes for animations */}
      <style>{`
        @keyframes float {
          0%, 100% { transform: translateY(0) translateX(0); }
          25% { transform: translateY(-20px) translateX(10px); }
          50% { transform: translateY(-10px) translateX(-10px); }
          75% { transform: translateY(-30px) translateX(5px); }
        }
      `}</style>

      <Chat />
      <DemoFooter />
    </div>
  )
}

export default Contact
